export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7461.82a70427.jpg";